'use strict';
'use es6';

// These should be removed once we have 100% adoption of UIApplication

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

require('../listeners/focusStylesListener');

var _setupStyledComponents = require('../listeners/setupStyledComponents');

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _Functions = require('../core/Functions');

var _UnsafeUrl = require('../utils/UnsafeUrl');

var _Links = require('../utils/Links');

var _TabIndex = require('../utils/TabIndex');

var _Hoverable = require('../decorators/Hoverable');

var _Hoverable2 = _interopRequireDefault(_Hoverable);

var _Activeable = require('../decorators/Activeable');

var _Activeable2 = _interopRequireDefault(_Activeable);

var _ShareButton = require('../decorators/ShareButton');

var _ShareButton2 = _interopRequireDefault(_ShareButton);

var _Translatable = require('../decorators/Translatable');

var _Translatable2 = _interopRequireDefault(_Translatable);

var _validHref = require('../utils/propTypes/validHref');

var _validHref2 = _interopRequireDefault(_validHref);

var _refObject = require('../utils/propTypes/refObject');

var _refObject2 = _interopRequireDefault(_refObject);

var _tshirtSize = require('../utils/propTypes/tshirtSize');

var TShirtSize = _interopRequireWildcard(_tshirtSize);

var _UITruncateString = require('../text/UITruncateString');

var _UITruncateString2 = _interopRequireDefault(_UITruncateString);

var _UIClickable = require('./UIClickable');

var _UIClickable2 = _interopRequireDefault(_UIClickable);

var _UIIcon = require('../icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _icons = require('icons/icons');

var _icons2 = _interopRequireDefault(_icons);

var _ButtonConstants = require('../button/ButtonConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

(0, _setupStyledComponents.setupStyledComponents)();

var getClassName = function getClassName(active, block, className, disabled, hovered, responsive, computedSize, computedUse) {
  var unstyled = computedUse === 'unstyled';
  return (0, _reactUtils.classNames)('uiButton', 'private-button', _ButtonConstants.SIZE_CLASSES[computedSize] || _ButtonConstants.SIZE_CLASSES.default, _ButtonConstants.USE_CLASSES[computedUse], className, {
    'private-button--active': active && !unstyled,
    'private-button--block': block && !unstyled,
    'disabled private-button--disabled': disabled && !unstyled,
    'private-button--non-responsive': !responsive,
    'private-button--non-link': _ButtonConstants.LINK_USES.indexOf(computedUse) === -1,
    'private-button--hover': hovered
  });
};

var getUse = function getUse(use) {
  return use && _ButtonConstants.USE_CLASSES[use] ? use : 'secondary';
};

var renderContents = function renderContents(children) {
  var stringBuffer = '';
  var nextChildIndex = 0;
  var childArr = _react.Children.toArray(children);
  return _react.Children.map(children, function (child) {
    nextChildIndex += 1;
    if (child == null) {
      return null;
    }

    // in response to a breaking change in React 0.15
    // (https://facebook.github.io/react/blog/2016/04/07/react-v15.html#no-more-extra-ltspangts)
    // this wraps any bare strings within a <span> to provide a more
    // predictable DOM for applying automatic spacing rules.
    if (typeof child === 'string') {
      stringBuffer += child;
      if (childArr.length < nextChildIndex || typeof childArr[nextChildIndex] !== 'string') {
        var wrappedStringBuffer = _react2.default.createElement(
          'span',
          null,
          stringBuffer
        );
        stringBuffer = '';
        return wrappedStringBuffer;
      } else {
        return null;
      }
    }

    return child;
  });
};

var renderExternalButtonIcon = function renderExternalButtonIcon(external, I18n, iconProps) {
  if (!external) return null;

  // Opening links in a new window is an accessibility anti-pattern.
  // To mitigate this, we add accessible text in the icon to warn that
  // the link will be opened in a new window
  // @link http://diveintoaccessibility.info/day_16_not_opening_new_windows.html

  return _react2.default.createElement(_UIIcon2.default, _extends({}, iconProps, {
    'aria-label': I18n.text('salesUI.UILink.externalTitle'),
    className: iconProps.className || 'private-link--external__icon',
    name: _icons2.default.EXTERNALLINK
  }));
};

var renderTruncatedContents = function renderTruncatedContents(truncate, truncateStringProps, renderedContents, renderedExternalButtonIcon) {
  return truncate ? _react2.default.createElement(
    _UITruncateString2.default,
    _extends({
      innerClassName: 'private-button__truncate-string',
      useFlex: true,
      fixedChildren: renderedExternalButtonIcon
    }, truncateStringProps),
    _react2.default.createElement(
      'span',
      null,
      renderedContents
    )
  ) : renderedContents;
};

var renderLink = function renderLink(buttonRef, disabled, external, href, rel, target, truncate, rest, computedClassName, computedTabIndex, computedTarget, handleClick, handleMouseDown, wrappedContents, renderedExternalButtonIcon) {
  var computedRel = (0, _Links.getRel)(rel, computedTarget);

  var renderedLink = _react2.default.createElement(
    'a',
    _extends({}, rest, {
      'aria-disabled': disabled,
      className: computedClassName,
      href: (0, _UnsafeUrl.getSafeUrl)(href),
      onClick: handleClick,
      onMouseDown: handleMouseDown,
      rel: computedRel,
      ref: (0, _Functions.wrapRefObject)(buttonRef),
      tabIndex: computedTabIndex,
      target: computedTarget
    }),
    wrappedContents,
    truncate ? null : renderedExternalButtonIcon
  );
  return (0, _Links.renderSecurityTaggedLink)(href, renderedLink);
};

var renderButton = function renderButton(_useNativeButton, active, ariaPressed, buttonRef, disabled, rest, computedClassName, computedTabIndex, handleClick, handleMouseDown, wrappedContents) {
  var ButtonComponent = _useNativeButton ? 'button' : _UIClickable2.default;
  return _react2.default.createElement(
    ButtonComponent,
    _extends({}, rest, {
      'aria-pressed': ariaPressed != null ? ariaPressed : active,
      'aria-disabled': disabled,
      className: computedClassName,
      onClick: handleClick,
      onMouseDown: handleMouseDown,
      ref: (0, _Functions.wrapRefObject)(buttonRef),
      tabIndex: computedTabIndex
    }),
    wrappedContents
  );
};

var validateProps = function validateProps(external, size, use, computedTarget) {
  (0, _Links.warnIfShouldBeExternal)(external, computedTarget, 'UIButton');

  if (use === 'form' && size !== 'default') {
    _devLogger2.default.warn({
      message: 'UIButton: size="' + size + '" is not supported with use="form"',
      key: 'UIButton: form size'
    });
  }
};

var UIButton = _react2.default.createClass({
  displayName: 'UIButton',

  mixins: [_reactAddonsPureRenderMixin2.default],

  propTypes: {
    _useNativeButton: _react.PropTypes.bool,
    active: _react.PropTypes.bool,
    autoFocus: _react.PropTypes.bool,
    'aria-pressed': _react.PropTypes.bool,
    block: _react.PropTypes.bool,
    buttonRef: _refObject2.default,
    children: _react.PropTypes.node,
    className: _react.PropTypes.string,
    disabled: _react.PropTypes.bool.isRequired,
    external: _react.PropTypes.bool.isRequired,
    href: _validHref2.default,
    hovered: _react.PropTypes.bool,
    I18n: _react.PropTypes.object,
    iconProps: _react.PropTypes.object.isRequired,
    onClick: _react.PropTypes.func,
    onMouseDown: _react.PropTypes.func,
    responsive: _react.PropTypes.bool.isRequired,
    rel: _react.PropTypes.string,
    size: TShirtSize.propTypeForSizes(['xs', 'sm', 'md'], ['default']),
    tabIndex: _react.PropTypes.number,
    target: _react.PropTypes.string,
    truncate: _react.PropTypes.bool.isRequired,
    truncateStringProps: _react.PropTypes.object.isRequired,
    type: _react.PropTypes.oneOf(['button', 'reset', 'submit']).isRequired,
    use: _react.PropTypes.oneOf(Object.keys(_ButtonConstants.USE_CLASSES)).isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      _useNativeButton: true,
      disabled: false,
      external: false,
      iconProps: {},
      responsive: true,
      size: 'medium',
      truncate: false,
      truncateStringProps: {},
      type: 'button',
      use: 'secondary'
    };
  },
  componentDidMount: function componentDidMount() {
    var _props = this.props,
        autoFocus = _props.autoFocus,
        buttonRef = _props.buttonRef,
        href = _props.href;

    if (autoFocus && href) {
      if (buttonRef.current) buttonRef.current.focus();
    }
  },
  handleMouseDown: function handleMouseDown(evt) {
    var onMouseDown = this.props.onMouseDown;


    if (this.props.disabled) {
      evt.stopPropagation();
    }

    (0, _Functions.callIfPossible)(onMouseDown, evt);
  },
  handleClick: function handleClick(evt) {
    var onClick = this.props.onClick;

    if (this.props.disabled) {
      evt.preventDefault();
      evt.stopPropagation();
    } else {
      (0, _Functions.callIfPossible)(onClick, evt);
    }
  },
  render: function render() {
    var _props2 = this.props,
        _useNativeButton = _props2._useNativeButton,
        active = _props2.active,
        ariaPressed = _props2['aria-pressed'],
        block = _props2.block,
        buttonRef = _props2.buttonRef,
        children = _props2.children,
        className = _props2.className,
        disabled = _props2.disabled,
        external = _props2.external,
        hovered = _props2.hovered,
        href = _props2.href,
        I18n = _props2.I18n,
        iconProps = _props2.iconProps,
        __onClick = _props2.onClick,
        __onMouseDown = _props2.onMouseDown,
        rel = _props2.rel,
        responsive = _props2.responsive,
        size = _props2.size,
        tabIndex = _props2.tabIndex,
        target = _props2.target,
        truncate = _props2.truncate,
        truncateStringProps = _props2.truncateStringProps,
        use = _props2.use,
        rest = _objectWithoutProperties(_props2, ['_useNativeButton', 'active', 'aria-pressed', 'block', 'buttonRef', 'children', 'className', 'disabled', 'external', 'hovered', 'href', 'I18n', 'iconProps', 'onClick', 'onMouseDown', 'rel', 'responsive', 'size', 'tabIndex', 'target', 'truncate', 'truncateStringProps', 'use']);

    var computedSize = TShirtSize.fromProp(size).long;
    var computedUse = getUse(use);
    var computedClassName = getClassName(active, block, className, disabled, hovered, responsive, computedSize, computedUse);
    var computedTabIndex = (0, _TabIndex.getTabIndex)(disabled, tabIndex);
    var computedTarget = (0, _Links.getTarget)(external, target);

    validateProps(external, size, use, computedTarget);

    var renderedContents = renderContents(children);
    var renderedExternalButtonIcon = renderExternalButtonIcon(external, I18n, iconProps);
    var wrappedContents = renderTruncatedContents(truncate, truncateStringProps, renderedContents, renderedExternalButtonIcon);

    return href ? renderLink(buttonRef, disabled, external, href, rel, target, truncate, rest, computedClassName, computedTabIndex, computedTarget, this.handleClick, this.handleMouseDown, wrappedContents, renderedExternalButtonIcon) : renderButton(_useNativeButton, active, ariaPressed, buttonRef, disabled, rest, computedClassName, computedTabIndex, this.handleClick, this.handleMouseDown, wrappedContents);
  }
});

exports.default = (0, _ShareButton2.default)((0, _Activeable2.default)((0, _Hoverable2.default)((0, _Translatable2.default)(UIButton))));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1282/js/button/UIButton.js
// module id = 25
// module chunks = 0